module.exports = __webpack_public_path__ + "img/community.2e2cac17.svg";